<template>
  <div>
		<div class="separator separator--mobile">
			<div class="infobox infobox--blank">
				<div class="infobox__col">
					<section class="section-wrapper section-wrapper--infinite">
						<h1 class="title u-weight-bolder" v-html="$t('about.introducerTitle')"></h1>
						<p class="text">{{ $t('about.introducerText1') }}</p>
						<p class="text">{{ $t('about.introducerText2') }}</p>
						<p class="text">{{ $t('about.introducerText3') }}</p>
					</section>
				</div>
				<div class="infobox__col">
					<img src="@/assets/pages/about/introducer.jpg" class="infobox__image"/>
				</div>
			</div>
		</div>

		<div class="jumbotron jumbotron--ribbon jumbotron--large jumbotron--plainBg jumbotron--padded">
			<div class="page-wrapper">
				<h2 class="title u-weight-bolder title--jumbotron title--bottomGap">{{ $t('about.counterTitle') }}</h2>
				<p class="text text--centered">{{ $t('about.counterIntro') }}</p>
				<ul class="stats">
					<li class="stats__item">
						<div class="stats__wrap">
							<img src="@/assets/pages/about/ico_market.svg" class="stats__img" alt="Markets"/>
							<div class="stats__number" id="markets">{{ $t('about.firstStatNumber') }}</div>
							<div class="stats__detail">{{ $t('about.firstStatDetail') }}</div>
						</div>
					</li>
					<li class="stats__item">
						<div class="stats__wrap">
							<img src="@/assets/pages/about/ico_CRM.svg" class="stats__img" alt="Markets"/>
							<div class="stats__number" id="crmUsers">{{ $t('about.secondStatNumber') }}</div>
							<div class="stats__detail">{{ $t('about.secondStatDetail') }}</div>
						</div>
					</li>
					<li class="stats__item">
						<div class="stats__wrap">
							<img src="@/assets/pages/about/ico_mobile.svg" class="stats__img" alt="Markets"/>
							<div class="stats__number" id="mobileUsers">{{ $t('about.thirdStatNumber') }}</div>
							<div class="stats__detail">{{ $t('about.thirdStatDetail') }}</div>
						</div>
					</li>
				</ul>
			</div>
		</div>

		<div class="separator seperator--mobile">
			<div class="page-wrapper">
				<h2 class="title u-weight-bolder title--team">{{ $t('about.teamTitle') }}</h2>
				<p class="text text--centered">{{ $t('about.teamIntro') }}</p>
				<div class="l-grid l-g-50 team-wrap">
					<div class="l-grid__col-100 l-grid__col-sm-50 l-grid__col-lg-25 people">
						<div class="people__wrap">
							<img class="people__image" src="@/assets/pages/about/charles.jpg" alt=""/>
							<p class="text">
								<span class="people__name">Charles Drouin</span>
								<span class="people__title">{{ $t('about.ceoTitle') }}</span>
							</p>
						</div>
					</div>
					<div class="l-grid__col-100 l-grid__col-sm-50 l-grid__col-lg-25 people">
						<div class="people__wrap">
							<img class="people__image" src="@/assets/pages/about/lisa.jpg" alt=""/>
							<p class="text">
								<span class="people__name">Lisa Gaetz</span>
								<span class="people__title">{{ $t('about.marketingTitle') }}</span>
							</p>
						</div>
					</div>
					<div class="l-grid__col-100 l-grid__col-sm-50 l-grid__col-lg-25 people">
						<div class="people__wrap">
							<img class="people__image" src="@/assets/pages/about/andy.jpg" alt=""/>
							<p class="text">
								<span class="people__name">Andy Murphy</span>
								<span class="people__title">{{ $t('about.mlsTitle') }}</span>
							</p>
						</div>
					</div>
					<div class="l-grid__col-100 l-grid__col-sm-50 l-grid__col-lg-25 people">
						<div class="people__wrap">
							<img class="people__image" src="@/assets/pages/about/marc.jpg" alt=""/>
							<p class="text">
								<span class="people__name">Marc-Antoine Juanéda</span>
								<span class="people__title">{{ $t('about.productTitle') }}</span>
							</p>
						</div>
					</div>
					<div class="l-grid__col-100 l-grid__col-sm-50 l-grid__col-lg-25 people">
						<div class="people__wrap">
							<img class="people__image" src="@/assets/pages/about/marie.jpg" alt=""/>
							<p class="text">
								<span class="people__name">Marie Leduc</span>
								<span class="people__title">{{ $t('about.serviceTitle') }}</span>
							</p>
						</div>
					</div>
					<div class="l-grid__col-100 l-grid__col-sm-50 l-grid__col-lg-25 people">
						<div class="people__wrap">
							<img class="people__image" src="@/assets/pages/about/mariepierre.jpg" alt=""/>
							<p class="text">
								<span class="people__name">Marie-Pierre Chamberland</span>
								<span class="people__title">{{ $t('about.businessTitle') }}</span>
							</p>
						</div>
					</div>
					<div class="l-grid__col-100 l-grid__col-sm-50 l-grid__col-lg-25 people">
						<div class="people__wrap">
							<img class="people__image" src="@/assets/pages/about/chantal.jpg" alt=""/>
							<p class="text">
								<span class="people__name">Chantal Leduc</span>
								<span class="people__title">{{ $t('about.businessTitle') }}</span>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div id="careers" class="jumbotron jumbotron--large jumbotron--image jumbotron--redTrans" :style="'background-image: url(' + require('@/assets/pages/about/working.jpg') + ')'">
			<div class="page-wrapper page-wrapper--centerd">
				<h1 class="title u-weight-bolder title--white title--bottomGap">{{ $t('about.jobText') }}</h1>
				<h2 class="subtitle subtitle--bottomGap title--white">{{ $t('about.jobSubtitle') }}</h2>
				<a href="https://corelogic.wd5.myworkdayjobs.com/USCAN?locations=e0052c9790670137e67fb5f5cc074144" class="button button--light button--squared button--large">{{ $t('about.careerBtn') }}</a>
			</div>
		</div>
  </div>
</template>


<script>

import Introducer from '@/components/utils/Introducer.vue'

export default {
	components: { Introducer },

	mounted () {
		
	},

	data () {
		return {

		}
	},

	computed: {

	},

	methods: {

	}
};

</script>

<style lang="scss" scoped>
	//breakpoints
	$screen-sm: 576px;
	$screen-md: 768px;
	$screen-lg:	992px;
	$screen-xl:	1280px;
	$screen-xxl: 1540px;

	//breakpoints mixin

	@mixin media-breakpoint-up($class) {

	  @if $class == sm {
	    @media (min-width: $screen-sm) { @content; }
	  }

	  @else if $class == md {
	    @media (min-width: $screen-md) { @content; }
	  }

	  @else if $class == lg {
	    @media (min-width: $screen-lg) { @content; }
	  }

	   @else if $class == xl {
	    @media (min-width: $screen-xl) { @content; }
	  }

	   @else if $class == xxl {
	    @media (min-width: $screen-xxl) { @content; }
	  }

	  @else {
	    @warn "Breakpoint mixin supports: xs, sm, md, lg, xl, xxl";
	  }
	}



	
	.infobox--blank { background: none;
	}
	.infobox__col {
		&:first-child {
			background: #f9f9f9;
			margin-right: 0px;
			@include media-breakpoint-up(lg) {
				margin-right: 20px;
			}
		}
	}
	.infobox__col--reversed {
		order: 0;
		&:first-child {
			order: 1;
			margin: 0 0 0 20px;
		}
	}

	.jumbotron--plainBg {
		background: #f9f9f9;
	}
	.jumbotron--padded {
		padding-top: 60px;;
		padding-bottom: 60px;;
	}
	.title {
		&--team {
			text-align: center;
			margin-bottom: 20px;
		}
		&--bottomGap { margin-bottom: 15px;}
	}

	.seperator--team { padding-top: 60px;}
	.team-wrap {
		justify-content: center;
		margin-top: 50px;
	}

	.people { 
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;
		}
	.people__wrap {
		-webkit-box-shadow: 0px -2px 7px -1px rgba(0,0,0,0.2);
		-moz-box-shadow: 0px -2px 7px -1px rgba(0,0,0,0.2);
		box-shadow: 0px -2px 7px -1px rgba(0,0,0,0.2);
		border-bottom: 1px solid #c51b1e;
		width: 100%;
		display: flex;
		flex-direction: column;
		height: 100%;
		justify-content: flex-start;
		align-items: center;
	}
	.people__image {
		width: 100%;
		max-width: 100%;
		height: auto;
		overflow: hidden;
	}
	.people__name { 
		margin-top: 20px;
		font-size: 2.0rem;
		font-weight: 500;
		line-height: 1;
		text-transform: uppercase;
		color: #c51b1e;
	}
	.people__name--strong {
		font-weight: 700;
	}
	.people__title { line-height: 1; font-weight: 500; font-size: 1.5rem; color: #717c7e; margin-bottom: 20px; margin-top: 10px; min-height: 35px; padding: 0 30px; }
	.people__description, .people__name, .people__title { display: block; }
	
	.jumboton__textbloc {
		border-radius: 5px;
		padding: 20px;
		margin-top: 20px;
		background-color: rgba(0, 0, 0, 0.4);
		&--50 { width: 50%;}
	}
	.jumbotron--redTrans {
		position: relative;
		&:before {
			content: ' ';
			background-color: rgba(197, 27, 30, 0.7);
			position: absolute;
			width: 100%;
			height: 100%;
			z-index: 2;
		}
	}

	.stats {
		display: flex;
		list-style-type: none;
		justify-content: space-between;
		padding: 50px 0 0;
		flex-direction: column;
		@include media-breakpoint-up(sm) {
			flex-direction: row;
		}
	}
	.stats__item {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-grow: 1;
		@include media-breakpoint-up(sm) {
			flex-basis: 257px;
		}
	}

	.stats__wrap {
	 	display: flex;
	 	flex-direction: column;
		width: 100%;
		max-width: 157px;
		@include media-breakpoint-up(sm) {
			max-width: 257px;
		}
	}
	.stats__img { 
		width: 100%;
		max-width: 100%;
		height: auto;
		margin-bottom: 25px;
	}
	.stats__number {
		color: #c51b1e;
		font-size: 2.4rem;
		font-weight: 600;
		margin-bottom: 25px;
		@include media-breakpoint-up(sm) {
			font-size: 3.4rem;
		}
	}
	.stats__detail {font-size: 1.5rem; font-weight: 600; margin-bottom: 25px;}

	.page-wrapper--centerd{
		align-items: center;
		display: flex;
		z-index: 99;
		flex-direction: column;
	}
	.text--textbloc {
		margin-bottom: 15px;
		line-height: 2.5rem;
	}
	.text--centered {
		text-align: center;
	}
	.button--light { background: none; border: 3px solid #fff;}
	.button--squared { border-radius: 0;}
	.subtitle--bottomGap { margin-bottom: 50px;}
</style>
